var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('progress-header'),_vm._v(" "),_c('taxi-search-form',{attrs:{"offer-type":"bt","split-adults-children":false,"initial-params":_vm.searchFormParams},on:{"search":_vm.search,"startPlacesFetched":_vm.startPlacesFetched,"endPlacesFetched":_vm.endPlacesFetched}}),_vm._v(" "),_c('search-tips',{attrs:{"type":"bt"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }